import * as React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../../ui/ActionButton/ActionButton'

import media from '../../../services/generateMediaQueries'

import SelectMallImage from '../../../assets/img/feature-statuses/tile_menu_icon_explore.png'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
    border-radius: 0;
    max-width: unset;
  `}
`

const ModalContent = styled.div`
  position: relative;
  padding: 2rem;
  padding-top: 3rem;
  margin: 0 auto;
  width: 325px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
`

const ModalImage = styled.img.attrs({ src: SelectMallImage })`
  display: block;
  margin: 0 auto;
  margin-bottom: 2.375rem;
  width: 15rem;
`

const Description = styled.p`
  color: var(--color-primary);
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
  margin: 0;
  margin-bottom: 2.5rem;
`

const BlockActionButton = styled(ActionButton)`
  width: 100%;
`

const overlay = {
  zIndex: 999,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function SelectMallPromptModal(props) {
  const { show, onConfirmClick } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{ overlay, content }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <ModalContent>
        <ModalImage />
        <Description>
          Which Ayala Mall would you like to explore today?
        </Description>
        <BlockActionButton variant="primary" onClick={onConfirmClick}>
          Select a Mall Now
        </BlockActionButton>
      </ModalContent>
    </StyledReactModal>
  )
}

SelectMallPromptModal.defaultProps = {}

SelectMallPromptModal.propTypes = {
  // TODO: specify prop types
}

export default SelectMallPromptModal
